export default (token => {
  if (!token || typeof token !== 'string') {
    return {
      property: '',
      prefix: '',
      tokenPath: '',
      formattedToken: ''
    };
  }

  // DEV NOTE: Tokens coming in from a propertyValue object can sometimes
  // have curly braces around them. Remove them here.
  const cleanedToken = token.replace('{{', '').replace('}}', '').trim();
  const splitToken = cleanedToken.split('.');
  const property = splitToken.pop() || '';
  const prefix = splitToken.join('.') || '';
  return {
    property,
    prefix,
    tokenPath: cleanedToken,
    // Just the inner part of token like my.token.path without curly braces
    formattedToken: `{{ ${cleanedToken} }}` // The full token including curly braces,
  };
});